import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  if (amount === undefined || amount === null) return '₹ 0';
  
  const num = Number(amount);
  if (isNaN(num)) return '₹ 0';
  
  // Indian numbering system
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  
  return formatter.format(num);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getToday() {
  return new Date().toISOString().split('T')[0];
}

export function getDateRange(type) {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-indexed
  const pad = (n) => String(n).padStart(2, '0');

  switch (type) {
    case 'today': {
      return {
        start_date: getToday(),
        end_date: getToday()
      };
    }
    case 'this-week': {
      const day = now.getDay();
      const diffToMon = day === 0 ? 6 : day - 1;
      const monday = new Date(now);
      monday.setDate(now.getDate() - diffToMon);
      return {
        start_date: `${monday.getFullYear()}-${pad(monday.getMonth() + 1)}-${pad(monday.getDate())}`,
        end_date: getToday()
      };
    }
    case 'current-month': {
      return {
        start_date: `${year}-${pad(month + 1)}-01`,
        end_date: getToday()
      };
    }
    case 'previous-month': {
      const pm = month === 0 ? 11 : month - 1;
      const py = month === 0 ? year - 1 : year;
      const lastDay = new Date(py, pm + 1, 0).getDate();
      return {
        start_date: `${py}-${pad(pm + 1)}-01`,
        end_date: `${py}-${pad(pm + 1)}-${pad(lastDay)}`
      };
    }
    case 'current-quarter': {
      const qStart = Math.floor(month / 3) * 3;
      return {
        start_date: `${year}-${pad(qStart + 1)}-01`,
        end_date: getToday()
      };
    }
    case 'previous-quarter': {
      let qStart = Math.floor(month / 3) * 3 - 3;
      let qy = year;
      if (qStart < 0) { qStart += 12; qy -= 1; }
      const qEnd = qStart + 2;
      const lastDay = new Date(qy, qEnd + 1, 0).getDate();
      return {
        start_date: `${qy}-${pad(qStart + 1)}-01`,
        end_date: `${qy}-${pad(qEnd + 1)}-${pad(lastDay)}`
      };
    }
    case 'current-fy': {
      // Indian FY: Apr to Mar
      const fyStartYear = month >= 3 ? year : year - 1;
      return {
        start_date: `${fyStartYear}-04-01`,
        end_date: getToday()
      };
    }
    case 'previous-fy': {
      const fyStartYear = month >= 3 ? year - 1 : year - 2;
      return {
        start_date: `${fyStartYear}-04-01`,
        end_date: `${fyStartYear + 1}-03-31`
      };
    }
    case 'full-ledger': {
      return {
        start_date: '2000-01-01',
        end_date: getToday()
      };
    }
    default:
      return { start_date: '', end_date: '' };
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
